module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "issue-notifications-registration-page-url",
    attrs: {
      "href": _vm.issueNotificationsLoginPageUrl
    }
  }, [_vm._v(_vm._s(_vm.issueNotificationsLoginPageLinkText))]), _vm._v(" "), (_vm.hasSelectedIssueInformation()) ? _c('div', {
    staticClass: "panel notice"
  }, [(_vm.hasSelectedIssueInformation()) ? _c('div', [_c('h2', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.NotificationPopupHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ProceedingTitle))])]) : _vm._e(), _vm._v(" "), (_vm.hasSelectedCommitteeInformation()) ? _c('div', [_c('h2', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.NotificationPopupHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.CommitteeTitle))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article-excerpt",
    domProps: {
      "innerHTML": _vm._s(_vm.Ingress)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-article block-article-mobile",
    domProps: {
      "innerHTML": _vm._s(_vm.MainBody)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "aria-live": "polite"
    }
  }, [(!_vm.showNewContactEmailSentConfirmation) ? _c('div', [_c('h2', {
    attrs: {
      "id": "registration-form-heading"
    }
  }, [_vm._v(_vm._s(_vm.EmailHeading))]), _vm._v(" "), (_vm.showNewContactError) ? _c('div', [_c('div', {
    staticClass: "panel alarmbanner"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.newContactErrorMessage) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 columns form-area"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.EmailPlaceholder,
      "aria-labelledby": "registration-form-heading"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "checkbox-fullwidth"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gdpr.consentGiven.registerNewUser),
      expression: "gdpr.consentGiven.registerNewUser"
    }],
    attrs: {
      "type": "checkbox",
      "name": "gdpr-consent-checkbox-register-new-user",
      "id": "gdpr-consent-checkbox-register-new-user"
    },
    domProps: {
      "checked": Array.isArray(_vm.gdpr.consentGiven.registerNewUser) ? _vm._i(_vm.gdpr.consentGiven.registerNewUser, null) > -1 : (_vm.gdpr.consentGiven.registerNewUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gdpr.consentGiven.registerNewUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gdpr.consentGiven.registerNewUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gdpr.consentGiven.registerNewUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.gdpr.consentGiven, "registerNewUser", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gdpr-consent-checkbox-register-new-user"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.gdpr.consentText) + " "), _c('a', {
    attrs: {
      "href": _vm.gdpr.privacyPolicyUrl
    }
  }, [_vm._v(_vm._s(_vm.gdpr.privacyPolicyLinkText))])])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(this.$root.dataRecaptchaInformationText)
    }
  })])]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "issue-notification-cta-container"
  }, [(_vm.working) ? _c('img', {
    staticClass: "loader-gif",
    attrs: {
      "src": "/Web/FrontEndR/assets/gfx/loader-transparent.gif"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button submit",
    attrs: {
      "type": "button",
      "disabled": this.registrationTriggered === true || this.newEmail === '' || !_vm.gdpr.consentGiven.registerNewUser
    },
    on: {
      "click": function($event) {
        _vm.submitWithRecaptcha(_vm.registerUser)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.CreateSubscriptionButtonText))])])]), _vm._v(" "), _c('p')]) : _c('div', [_c('div', {
    staticClass: "panel notice"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.SubscriptionConfirmationPopupText)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f937ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/IssueNotificationsRegistration.vue
// module id = 91
// module chunks = 1